// test1394
(1394 && 0);
